import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import NotFound from '~/pages/NotFound';

import CertificateCareerAcelerator from '~/pages/Certificate/acelerador-carreira';
import CertificatePythonWeek from '~/pages/Certificate/semana-python';
import CertificateExcelWeek from '~/pages/Certificate/semana-excel';
import CertificateEspanhol from '~/pages/Certificate/espanhol';
import CertificateEspanholExcel from '~/pages/Certificate/espanhol-excel';
import CertificateIaWeek from '~/pages/Certificate/semana-ia';
import CertificateEspanholPython from '~/pages/Certificate/latam-python';
import CertificateIaEspanhol from '~/pages/Certificate/semana-ia-latam';
import CertificateAgentesIaLatam from '~/pages/Certificate/agentes-ia-latam';

const Routes = () => (
  <Route
    render={({ location }) => (
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path="/certificado-python" component={CertificatePythonWeek} />
          <Route path="/certificado-excel" component={CertificateExcelWeek} />
          <Route path="/certificado" component={CertificateCareerAcelerator} />
          <Route path="/latam" component={CertificateEspanhol} />
          <Route path="/latam-excel" component={CertificateEspanholExcel} />
          <Route path="/latam-python" component={CertificateEspanholPython} />
          <Route path="/certificado-ia" component={CertificateIaWeek} />
          <Route path="/certificado-ia-latam" component={CertificateIaEspanhol} />
          <Route path="/certificado-agentes-ia-latam" component={CertificateAgentesIaLatam} />
          <Route path="*" component={NotFound} />
        </Switch>
      </AnimatePresence>
    )}
  />
);

export default Routes;
